import { render, staticRenderFns } from "./SchoolCompare.vue?vue&type=template&id=de1c5638&"
import script from "./SchoolCompare.vue?vue&type=script&lang=js&"
export * from "./SchoolCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports